module.exports = __webpack_public_path__ + "static/media/lifeline_step_5.41ea99cf.png";